import React from 'react';

import { mq } from 'react-scale/components/website/big/Themes';

const Item = ({ onClick, type, text, number, numberBackground, children }) => (
  <li>
    {onClick && (
      <div
        className="wrapper"
        onClick={() => onClick(type)}
        onMouseEnter={() => onClick(type)}
        onMouseLeave={() => onClick('')}
      >
        {children}
        <span className="number">{number}</span>
        <div>
          <span className="text">{text}</span>
        </div>
      </div>
    )}
    {!onClick && (
      <div className="wrapper">
        {children}
        <span className="number">{number}</span>
        <div>
          <span className="text">{text}</span>
        </div>
      </div>
    )}
    <style jsx>{`
      li {
        cursor: default;
      }
      li:not(:last-child) {
        margin-bottom: calc(2rem / 2);
      }
      @media (min-width: ${mq.lg}) {
        li:last-child {
          margin-bottom: 0;
        }
      }
      li .wrapper {
        display: flex;
        align-items: center;
        position: relative;
      }
      
      .number {
        color: white;
        font-size: 18px;
        font-weight: bold;
        line-height: 2rem;
        text-align: center;
        background-color: ${numberBackground};
        width: 2rem;
        height: 2rem;
        margin-right: calc(2rem / 2);
        border-radius: 100%;
        flex-shrink: 0;
      }
      
      .text {
        color: #008eff;
        display: inline;
        border-bottom: 1px dashed #008EFF;
      }
    `}</style>
  </li>
);

export default Item;
